// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7088":"4bd37bb9","9417":"b2197055"}[chunkId] + ".chunk.css";
};